import { jsx as L, jsxs as l } from "react/jsx-runtime";
import "react";
var F = (t) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1392 -172)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.54813 6.54022L7.31145 8.88956H9.78172L7.78324 10.3416L8.5466 12.6909L6.54813 11.2389L4.54961 12.6909L5.31297 10.3416L3.31445 8.88956H5.78473L6.54813 6.54022Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.3586 14.3541L10.6091 13.8096L9.85969 14.3541L10.1459 13.4731L9.39648 12.9286H10.3229L10.6091 12.0476L10.8954 12.9286H11.8217L11.0723 13.4731L11.3586 14.3541Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.3139 11.6631H12.3876L12.1013 12.5441L11.8151 11.6632L10.8887 11.6631L11.6382 11.1186L11.3519 10.2376L12.1014 10.7821L12.8508 10.2376L12.5645 11.1186L13.3139 11.6631Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.3139 8.33697L12.5645 8.8815L12.8507 9.7624L12.1013 9.21802L11.3518 9.76247L11.6381 8.88142L10.8887 8.33697L11.815 8.33693L12.1013 7.45587L12.3875 8.33693L13.3139 8.33697Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.3585 5.64591L11.0723 6.52697L11.8216 7.07142L10.8954 7.07146L10.6091 7.95255L10.3228 7.07142L9.39648 7.0715L10.1459 6.52693L9.85961 5.64587L10.609 6.19044L11.3585 5.64591Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  F as default
};
